import { request } from '../utils/fetchClient';

export const login = async (loginData) => {
    const response = await request('/auth/login', {
        method: 'POST',
        data: loginData
    });
    return response;
};

export const register = async (userData) => {
    const response = await request('/auth/register', {
        method: 'POST',
        data: userData
    });
    return response;
};

export const telegramAuth = async (telegramData) => {
    const params = new URLSearchParams({
        telegram_id: telegramData.telegram_id,
        ...(telegramData.telegram_username && { telegram_username: telegramData.telegram_username }),
        ...(telegramData.first_name && { first_name: telegramData.first_name }),
        ...(telegramData.last_name && { last_name: telegramData.last_name })
    });
    
    const response = await request(`/auth/telegram-auth?${params}`, {
        method: 'POST'
    });
    return response;
};

export const autoLogin = async () => {
    const response = await request('/auth/auto-login');
    return response;
};

export const autoLoginBrowser = async () => {
    const response = await request('/auth/auto-login-browser', {
        method: 'POST'
    });
    return response;
};

export const logout = async () => {
    const response = await request('/auth/logout', {
        method: 'POST'
    });
    return response;
};

export const getMe = async () => {
    const response = await request('/auth/me');
    return response;
}; 